import { Alert, Card, SkeletonItem, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: ${({ theme }) => theme.spacings.large} ${({ theme }) => theme.spacings.small}
			${({ theme }) => theme.spacings.small} ${({ theme }) => theme.spacings.small};

		${({ theme }) => theme.breakpoints.queries.above.tabletSmallDesktop} {
			padding: ${({ theme }) => theme.spacings.xxlarge} 0;
		}
	`;

	export const ConfirmPasswordCard = styled(Card)`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.medium};
		max-width: 100%;
	`;
	export const Title = styled(Text)`
		margin: 0 0 ${({ theme }) => theme.spacings.medium};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
	export const TitleSkeletonItem = styled(SkeletonItem)`
		width: 320px;
	`;
	export const FormContainer = styled.div`
		display: flex;
		justify-content: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xsmall};
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	`;

	export const ButtonSection = styled.div`
		margin-top: ${({ theme }) => theme.spacings.xsmall};
		width: 100%;
		display: flex;
		justify-content: center;
	`;
	export const ButtonSectionNoPassword = styled.div`
		margin-top: ${({ theme }) => theme.spacings.xsmall};
		margin-bottom: ${({ theme }) => theme.spacings.small};
		width: 100%;
		display: flex;
		justify-content: center;
	`;
	export const AlertWrapper = styled(Alert)`
		width: 100%;
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;
	export const ButtonWrapper = styled.div`
		min-width: 100%;
		gap: ${({ theme }) => `${theme.spacings.xsmall}`};
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	`;
	export const TextInputSkeletonItem = styled(SkeletonItem)`
		height: 62px;
	`;
}
